export default __webpack_public_path__ + "static/media/search-tasks.80b31b3f.png";